import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Sparkles, X } from "lucide-react";

/**
 * Polls for unseen milestones and displays a celebration card.
 * Mounted globally; only visible when a milestone is unseen.
 */
const MilestoneCelebration = ({ authed, triggerKey }) => {
  const [current, setCurrent] = useState(null);

  const check = async () => {
    try {
      const { data } = await api.get("/me/milestones");
      if (data.unseen && data.unseen.length > 0) {
        setCurrent(data.unseen[0]);
      }
    } catch {}
  };

  useEffect(() => {
    if (!authed) {
      setCurrent(null);
      return;
    }
    check();
    // eslint-disable-next-line
  }, [authed, triggerKey]);

  const dismiss = async () => {
    if (!current) return;
    try {
      await api.post(`/me/milestones/${current.id}/seen`);
    } catch {}
    setCurrent(null);
    // A brief delay then check again in case there's another queued
    setTimeout(() => check(), 400);
  };

  if (!current) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-6 bg-black/60 backdrop-blur-sm fade-in"
      data-testid="milestone-modal"
    >
      <div className="relative max-w-md w-full card-surface p-10 text-center overflow-hidden">
        {/* Glow */}
        <div className="pointer-events-none absolute -top-20 -left-20 w-64 h-64 rounded-full bg-teal-500/20 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-20 -right-20 w-64 h-64 rounded-full bg-teal-400/10 blur-3xl" />

        <button
          onClick={dismiss}
          data-testid="milestone-close"
          className="absolute top-4 right-4 text-neutral-500 hover:text-neutral-200"
          aria-label="Close"
        >
          <X size={18} />
        </button>

        <div className="relative">
          <div className="mx-auto mb-6 w-16 h-16 rounded-full bg-teal-500/15 border border-teal-500/40 flex items-center justify-center pulse-ring">
            <Sparkles className="text-teal-300" size={26} />
          </div>
          <div className="text-xs uppercase tracking-[0.24em] text-teal-300/80 mb-3">Milestone</div>
          <h2 className="font-display text-3xl mb-4" data-testid="milestone-title">{current.title}</h2>
          <p className="text-neutral-300 leading-relaxed mb-8" data-testid="milestone-message">
            {current.message}
          </p>
          <button
            onClick={dismiss}
            data-testid="milestone-continue"
            className="btn-primary px-6 py-2.5"
          >
            Keep going
          </button>
        </div>
      </div>
    </div>
  );
};

export default MilestoneCelebration;
